import React, { useEffect, useState } from "react";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import NoResourceMessage from "../resources/NoResourceMessage";
import SimpleResourceItems from "../resources/SimpleResourceItems";

function ExerciseOptions(props) {
  const [exerciseVideos, setExerciseVideos] = useState([]);
  const [exercisePresentations, setExercisePresentations] = useState([]);
  const [dataPulled, setDataPulled] = useState(false);
  const handleExerciseData = async () => {
    const response = await makeGetRequest(
      urls.resources + "?active=True&resource_type=5",
      "",
      true
    );
    setExerciseVideos(response.data);
    setDataPulled(true);
  };
  useEffect(() => {
    handleExerciseData();
  }, []);

  return (
      exerciseVideos.length === 0 & dataPulled === true ? <NoResourceMessage /> : <SimpleResourceItems items={exerciseVideos} />
  );
}

export default ExerciseOptions;
